// version, status, lastVersion, lastStatus, newAPK
// import _ from 'lodash'
import { isEmpty } from '../botAppCommon'
import Ph1Mapper from './ph1Mapper'
import Ph2Mapper from './ph2Mapper'
import Ph3Mapper from './ph3Mapper'

const appInfoState = (
    storeVer,
    storeState,
    applyVer,
    applyState,
    upgrade,
    publishType
) => {
    // let obj = _.merge(
    //     {
    //         storeVer: 1,
    //         storeState: 'draft',
    //         applyVer: null,
    //         applyState: null,
    //         upgrade: null,
    //         publishType: 'auto' // 除了 auto 以外，為立即發佈
    //     },
    //     {
    //         storeVer,
    //         storeState,
    //         applyVer,
    //         applyState,
    //         upgrade,
    //         publishType
    //     }
    // )

    let obj = {
        storeVer,
        storeState,
        applyVer,
        applyState,
        upgrade,
        publishType
    }

    if (!obj.storeVer) obj.storeVer = obj.applyVer
    // if (!obj.applyState) obj.storeState = obj.applyState
    if (isEmpty(obj.upgrade)) obj.upgrade = false

    return obj
}

const getBotAppPhase = opt => {
    // p1
    // version code 1
    // status draft

    // p2
    // version code 1
    // status published

    // p2
    // version code 1
    // status pending.
    // last status published

    // p3
    // version code 1.1 - new apk
    // status draft
    // last status published
    // last version code - 1

    // if (opt.applyState !== 'draft') {
    //     if (opt.storeState === 'unpublished' || opt.storeState === 'removed') {
    //         opt.applyState = opt.storeState
    //     }
    // }

    if (opt.storeState === 'unpublished') {
        // only way to p3_un
        return 'p3_lock'
    }

    // if (
    //     opt.storeState === null &&
    //     opt.applyState === 'published' &&
    //     !opt.upgrade
    // ) { return 'p2' } // app published first time
    if (opt.storeState === 'published' && !opt.upgrade) return 'p2' // app published and update app info.
    if (opt.storeVer < opt.applyVer && opt.upgrade) return 'p3' // upgrade ver apply
    if (opt.storeVer === opt.applyVer) return 'p1' // first draft
}

const appStatusMapper = opt => {
    let _opt = null
    // let arr = []
    // // let opt = {}
    // arr.push(opt)

    // opt = {
    //     lastVersionCode: null,
    //     lastStatus: null,
    //     version: 1,
    //     status: 'draft',
    //     newAPK: null,
    //     publishType: 'auto'
    // }
    // arr.push(opt)
    // opt = {
    //     lastVersionCode: null,
    //     lastStatus: null,
    //     version: 1,
    //     status: 'published',
    //     newAPK: null,
    //     publishType: 'manual'
    // }
    // arr.push(opt)
    // opt = {
    //     lastVersionCode: 1,
    //     lastStatus: 'draft',
    //     version: 1,
    //     status: 'published',
    //     newAPK: null,
    //     publishType: 'manual'
    // }
    // arr.push(opt)
    // opt = {
    //     lastVersionCode: 1,
    //     lastStatus: 'published',
    //     version: 2,
    //     status: 'draft',
    //     isUploadApk: true,
    //     publishType: 'manual'
    // }
    // arr.push(opt)
    // arr.map(opt => {
    //     getBotAppPhase(opt)
    // })
    _opt = appInfoState(
        // convert to private options
        opt.lastVersionCode,
        opt.lastStatus,
        opt.versionCode,
        opt.status,
        opt.isUploadApk,
        opt.publishType
    )
    let statusMapper = {
        p1: Ph1Mapper,
        p2: Ph2Mapper,
        p3: Ph3Mapper
    }
    // console.log('zevi :', JSON.stringify(statusMapper))
    console.log('zevi :', statusMapper)
    let phase = getBotAppPhase(_opt)
    let status = _opt.applyState
    console.log('phase', phase)
    let realPhase = phase
    if (phase === 'p3_lock') {
        phase = 'p3'
    }
    console.log('status', status)
    console.log('zevi2 :', statusMapper[phase][status])

    let applyStatus = statusMapper[phase][status] || statusMapper['p1']['draft']

    if (realPhase === 'p3_lock') {
        // update states
        applyStatus.button.discardAPK.enable = false
        applyStatus.storeCtrl.enable = false
    }

    return [applyStatus, phase]
}

export default appStatusMapper
